{
  "todayButton": "Heute",
  "nextMonth": "Nächster Monat",
  "previousMonth": "Letzter Monat",
  "nextYear": "Nächstes Jahr",
  "previousYear": "Letztes Jahr",
  "weekdays": [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ],
  "months": [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}
